import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useStateSelector } from '../store/';
import { selectSelectedOriginalService } from '../reducers/selectors';
import { CONSOLIDATED_STORE_ID } from '../services/appointment/model';
import { getQueryParamsFromURL } from '../helpers/urlHelper';
import { isStoreRemoteInConsolidatedCalendar } from '../helpers/appHelper';

interface UseStorePickerReturn {
  shouldShowStorePicker: boolean;
  storeList: Array<{ value: string; text: string }>;
}

export const useStorePicker = (serviceId: string): UseStorePickerReturn => {
  const { t } = useTranslation();
  const stores = useStateSelector((state) => state.stores.availableStores);
  const selectedOriginalService = useStateSelector(
    selectSelectedOriginalService,
  );

  const hideStoreSelector = getQueryParamsFromURL().storeSelector === false;

  const isConsolidatedCalendar =
    !!selectedOriginalService &&
    isStoreRemoteInConsolidatedCalendar(
      selectedOriginalService.location,
      serviceId,
      CSS_CONFIG,
    );

  const showConsolidatedCalendar = isConsolidatedCalendar && stores.length > 1;

  const shouldShowStorePicker =
    !!selectedOriginalService &&
    stores &&
    stores.length > 0 &&
    !(
      isConsolidatedCalendar &&
      CSS_CONFIG.services.consolidatedCalendar.showOnlyOneCalendar
    ) &&
    !hideStoreSelector;

  const storeList = useMemo(() => {
    const consolidatedCalendar = {
      value: CONSOLIDATED_STORE_ID,
      text: t('pages.timeslots.allStores'),
    };

    return [
      ...(showConsolidatedCalendar ? [consolidatedCalendar] : []),
      ...stores,
    ];
  }, [showConsolidatedCalendar, stores, t]);

  return {
    shouldShowStorePicker,
    storeList,
  };
};
